module.exports = __webpack_public_path__ + "static/media/welcome-right-img.6bdfc5af.svg";